import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

const C = {
  deepRed: "#A10F1A",
  gold: "#C79A3B",
  cream: "#F3EEE4",
  darkGold: "#8C6A24",
  richBrown: "#5A3A1A",
  black: "#1A1A1A",
  bgLight: "#FAF7F2",
  white: "#FFFFFF",
};

const testimonials = [
  {
    name: " Reena devi",
    designation: "",
    feedback:
      "I had a very positive experience with R & P Law Partners. My bail matter was personally h andled by the Team Ms. Ritika Gautam  and Mr. Prasoon Ranjan and I truly appreciate their dedication  and professionalism. Both of them were extremely polite, underst anding and supportive throughout the process. They explained every legal aspect clearly  and h andled the matter with great competence  and confidence. Their calm approach  and professionalism during a stressful situation made a huge difference. I highly recommend the firm to anyone seeking reliable legal assistance.",
  },
  {
    name: "Ravi Kumar",
    designation: "",
    feedback:
      "Very responsive  and professional. Ritika ma’am  and Adv Prasoon don’t make false promises  and tell you the reality of your case (whether need to fear or no need to fear). My divorce case, maintainance case  and DV case was h andled efficiently  and I got a very fair settlement. Previously I changed 3-4 advocate due to their false representation. After 4 years of long legal battles I found Best matrimonial advocate in Delhi. Thankyou Ritika Ma’am  and Prasoon Sir",
  },
  {
    name: "Kundan Kumar Singh",
    designation: "",
    feedback:
      "The way R & P Law Partners managed my bail case was exceptional. Ritika Ma’am’s drafting  and Prasoon Sir’s courtroom advocacy are simply unmatched. If you’re looking for the best bail lawyers in Delhi-NCR, look no further.",
  },
  {
    name: "AMIT KUMAR M andAL",
    designation: "",
    feedback:
      "Adv. Ritika Ma’am  and Adv. Prasoon Sir are exceptional lawyers. They secured bail for me within days  and h andled the entire process with great precision  and dignity. Their dedication  and constant updates gave me full confidence. Highly recommended firm!",
  },
  {
    name: "Manish",
    designation: "",
    feedback:
      "One of the best law firms I’ve dealt with. Both Mr. Prasoon  and Ritika Ma’am are extremely dedicated  and approachable. They h andled my companies commercial case very efficiently  and kept me informed at every step. It’s almost 2 years left, my case is pending for Judgement/Final Order.",
  },
];

const TestimonialSlider = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % testimonials.length);
    }, 6000);
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      {/* Responsive Breakpoint CSS Injection */}
      <style>{`
        .testimonial-grid {
          display: grid;
          grid-template-columns: 5fr 7fr;
          gap: 3.5rem;
          align-items: center;
          max-width: 1100px;
          margin: 0 auto;
        }
        @media (max-width: 900px) {
          .testimonial-grid {
            grid-template-columns: 1fr !important;
            gap: 2.5rem !important;
          }
        }
      `}</style>

      {/* ══ TOP LABEL STRIP ══ */}
      <div
        style={{
          background: C.deepRed,
          padding: "clamp(20px, 4vw, 50px) clamp(16px, 5vw, 64px)",
          display: "flex",
          alignItems: "center",
          gap: "clamp(10px, 2vw, 16px)",
          flexWrap: "wrap",
        }}
      >
        <div
          style={{
            height: 2,
            width: "clamp(30px, 8vw, 62px)",
            background: "rgba(199,154,59,0.6)",
            flexShrink: 0,
          }}
        />

        <span
          style={{
            fontSize: "clamp(18px, 4vw, 40px)",
            fontWeight: 700,
            color: C.gold,
            letterSpacing: "clamp(2px, 1vw, 8px)",
            textTransform: "uppercase",
            fontFamily: "sans-serif",
            lineHeight: 1.2,
          }}
        >
          Client Testimonials
        </span>
      </div>

      <section
        style={{
          width: "100%",
          background: C.bgLight,
          fontFamily: "'Georgia', 'Times New Roman', serif",
          padding: "5rem 4rem",
          boxSizing: "border-box",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <div className="testimonial-grid">
          {/* ══ LEFT: Heading & Navigation ══ */}
          <div>
            {/* Label */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                marginBottom: "1.75rem",
              }}
            >
              <div
                style={{
                  width: 32,
                  height: 2,
                  background: C.deepRed,
                  borderRadius: 2,
                }}
              />
              <span
                style={{
                  fontSize: 10,
                  fontWeight: 700,
                  color: C.darkGold,
                  letterSpacing: "0.45em",
                  textTransform: "uppercase",
                  fontFamily: "sans-serif",
                }}
              >
                What Our Clients Say
              </span>
            </div>

            {/* Heading */}
            <h2
              style={{
                fontSize: "clamp(32px, 4vw, 54px)",
                fontWeight: 700,
                color: C.black,
                margin: "0 0 1.25rem",
                lineHeight: 1.1,
              }}
            >
              Patron{" "}
              <span
                style={{
                  fontWeight: 300,
                  fontStyle: "italic",
                  color: C.deepRed,
                }}
              >
                Voices
              </span>
            </h2>
            {/* Subtext */}
            <p
              style={{
                fontSize: 14,
                color: C.richBrown,
                lineHeight: 1.85,
                fontFamily: "sans-serif",
                maxWidth: 320,
                margin: "0 0 2.5rem",
                borderLeft: `2px solid ${C.gold}`,
                paddingLeft: 18,
              }}
            >
              Our reputation is forged in the success of those we represent.
              Legacy is built on trust  and absolute legal mastery.
            </p>

            {/* Nav buttons */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "1.25rem",
              }}
            >
              {testimonials.map((t, i) => (
                <button
                  key={i}
                  onClick={() => setCurrentIndex(i)}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 16,
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    padding: 0,
                    width: "fit-content",
                  }}
                >
                  <span
                    style={{
                      fontSize: 13,
                      fontFamily: "'Georgia', serif",
                      fontWeight: 700,
                      color: currentIndex === i ? C.black : "#ccc",
                      transform: currentIndex === i ? "scale(1.2)" : "scale(1)",
                      transition: "all 0.4s",
                      minWidth: 20,
                      textAlign: "left",
                    }}
                  >
                    0{i + 1}
                  </span>

                  {/* Animated bar */}
                  <div
                    style={{
                      width: 40,
                      height: 1,
                      background: "rgba(140,106,36,0.15)",
                      overflow: "hidden",
                      position: "relative",
                      flexShrink: 0,
                    }}
                  >
                    <motion.div
                      initial={false}
                      animate={{ x: currentIndex === i ? 0 : -42 }}
                      transition={{ duration: 0.5 }}
                      style={{
                        position: "absolute",
                        inset: 0,
                        background: C.gold,
                      }}
                    />
                  </div>

                  <span
                    style={{
                      fontSize: 10,
                      textTransform: "uppercase",
                      letterSpacing: "0.3em",
                      fontFamily: "sans-serif",
                      color: C.black,
                      opacity: currentIndex === i ? 1 : 0.25,
                      transform:
                        currentIndex === i
                          ? "translateX(6px)"
                          : "translateX(0)",
                      transition: "all 0.4s",
                      textAlign: "left",
                    }}
                  >
                    {t.name}
                  </span>
                </button>
              ))}
            </div>
          </div>

          {/* ══ RIGHT: Testimonial Card ══ */}
          <div
            style={{
              position: "relative",
              minHeight: 380,
              display: "flex",
              alignItems: "center",
              width: "100%",
            }}
          >
            {/* Depth frames */}
            <div
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%) rotate(-2deg)",
                width: "96%",
                height: "90%",
                border: `1px solid rgba(199,154,59,0.25)`,
                pointerEvents: "none",
              }}
            />
            <div
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%) rotate(-4deg)",
                width: "96%",
                height: "90%",
                border: `1px solid rgba(199,154,59,0.12)`,
                pointerEvents: "none",
              }}
            />

            <AnimatePresence mode="wait">
              <motion.div
                key={currentIndex}
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -20 }}
                transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
                style={{
                  background: C.bgLight,
                  width: "100%",
                  padding: "3rem 2.5rem",
                  position: "relative",
                  boxSizing: "border-box",
                  zIndex: 2,
                }}
              >
                {/* Decorative left gold block line */}
                <div
                  style={{
                    position: "absolute",
                    top: "10%",
                    left: 0,
                    width: 2,
                    height: "80%",
                    background: C.gold,
                  }}
                />

                {/* Big decorative quote mark */}
                <div
                  style={{
                    position: "absolute",
                    top: "0.5rem",
                    right: "1.5rem",
                    fontSize: "8rem",
                    fontFamily: "'Georgia', serif",
                    lineHeight: 1,
                    color: C.gold,
                    opacity: 0.15,
                    userSelect: "none",
                    pointerEvents: "none",
                  }}
                >
                  ”
                </div>

                {/* Feedback text */}
                <p
                  style={{
                    color: C.richBrown,
                    fontSize: "clamp(15px, 1.8vw, 18px)",
                    fontStyle: "italic",
                    lineHeight: 1.8,
                    margin: "0 0 2rem",
                    position: "relative",
                    zIndex: 1,
                  }}
                >
                  "{testimonials[currentIndex].feedback}"
                </p>

                {/* Author */}
                <div style={{ position: "relative", zIndex: 1 }}>
                  <h4
                    style={{
                      fontSize: 13,
                      fontWeight: 700,
                      color: C.black,
                      textTransform: "uppercase",
                      letterSpacing: "0.25em",
                      margin: "0 0 4px",
                      fontFamily: "'Georgia', serif",
                    }}
                  >
                    {testimonials[currentIndex].name}
                  </h4>
                  <p
                    style={{
                      fontSize: 9,
                      color: C.darkGold,
                      textTransform: "uppercase",
                      letterSpacing: "0.35em",
                      fontFamily: "sans-serif",
                      margin: 0,
                    }}
                  >
                    {testimonials[currentIndex].designation}
                  </p>
                </div>
              </motion.div>
            </AnimatePresence>
          </div>
        </div>

        {/* Watermark Logo Backing */}
        <div
          style={{
            position: "absolute",
            bottom: "1rem",
            right: "2rem",
            fontSize: "clamp(24px, 4vw, 44px)",
            fontWeight: 900,
            textTransform: "uppercase",
            letterSpacing: "0.05em",
            color: C.black,
            opacity: 0.03,
            fontFamily: "'Georgia', serif",
            pointerEvents: "none",
            userSelect: "none",
          }}
        >
          R &amp; P LAW Team
        </div>
      </section>
    </>
  );
};

export default TestimonialSlider;
